export const iconFontAwesomeShapesShapes = (
	<i className="fa-solid fa-shapes"></i>
);
